import ConventionBrancheList from '@/generated/controls/convention/ConventionBrancheList.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: ConventionBrancheList
})
